// extracted by mini-css-extract-plugin
export default {"reviewsBreadcrumbSkipButton":"ReviewsBreadcrumb_reviewsBreadcrumbSkipButton__ssXLk"};